import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const NoAccessGlyph = /*#__PURE__*/createElement("g", {
  id: "no_access"
}, /*#__PURE__*/createElement("path", {
  d: "M42,15c-14.9,0-27,12.1-27,27s12.1,27,27,27s27-12.1,27-27S56.9,15,42,15z M42,18c6.1,0,11.6,2.3,15.9,6L24,57.9 c-3.7-4.2-6-9.8-6-15.9C18,28.8,28.8,18,42,18z M42,66c-6.1,0-11.6-2.3-15.9-6L60,26.1c3.7,4.2,6,9.8,6,15.9C66,55.2,55.2,66,42,66 z"
}));
const NoAccess = createSvg({
  name: 'no_access',
  path: NoAccessGlyph
});

export default NoAccess;
export { NoAccessGlyph };
